import { useLocation } from 'react-router';

import { catchAll } from '@sorare/routing';

import { ANY_SPORT_MY_CARDS } from '#src/constants/__generated__/routes.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { matchAnySportPath } from '#src/lib/routing/generateSportPath.ts';

export const useTransparentAppHeader = () => {
  const seriesNav = useSeriesNav();
  const { pathname } = useLocation();
  const isMyCards = !!matchAnySportPath(catchAll(ANY_SPORT_MY_CARDS), pathname);
  return seriesNav || isMyCards;
};
